import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../helpers/custom-prop-types';
import SplitText from '../../../Ui/Common/SplitText';
const LeftComponentForMember = (props) => {
    const { document } = props;
    const { description } = document;
    return (_jsx("div", Object.assign({ className: 'member_left_content' }, { children: description && (_jsx("div", Object.assign({ className: 'description' }, { children: _jsx(SplitText, { convertLink: true, text: description }) }))) })));
};
LeftComponentForMember.propTypes = {
    document: propShape().isRequired,
};
export default LeftComponentForMember;
